// utils/populateItemsUtil.js
import { buildSelectableMap } from './itemHelpers'

export const itemHandlersFactory = ({
  getCalibrationList,
  getServiceList,
  getPartsList,
  getLabourList,
  setAvailableCalibrations,
  setAvailableServices,
  setAvailableParts,
  setAvailableLabour
}) => {
  const itemHandlers = {
    calibrations: {
      fetch: getCalibrationList,
      set: setAvailableCalibrations,
      selectedKey: 'calibrations',
      productType: 'calibration'
    },
    services: {
      fetch: getServiceList,
      set: setAvailableServices,
      selectedKey: 'services',
      productType: 'service'
    },
    parts: {
      fetch: getPartsList,
      set: setAvailableParts,
      selectedKey: 'parts',
      productType: 'part'
    },
    labor: {
      fetch: getLabourList,
      set: setAvailableLabour,
      selectedKey: 'labours',
      productType: 'labour'
    }
  }

  const handleItems = async (handler, ccid, qwi_id, selected = [], extraParams = {}) => {
    const data = await handler.fetch({
      ccid,
      qwi_id,
      ...extraParams
    })

    // The document's existing lines are always listed (ticked), even when their product is not in this catalog.
    handler.set(buildSelectableMap(data, selected, handler.productType))
  }

  /**
   * Loads the catalog for `type` and sets the drawer data.
   * Resolves `true` when the drawer can be opened, `false` when the catalog could not be loaded
   * (the caller must not open the drawer then, or closing it would save a list built from nothing).
   */
  const populateSelectableItems = async (type, ccid, qwi_id, selected = {}, extraParams = {}) => {
    const handler = itemHandlers[type]
    if (!handler) {
      console.warn(`Unknown type: ${type}`)
      return false
    }

    try {
      const selectedItems = selected[handler.selectedKey] || []
      await handleItems(handler, ccid, qwi_id, selectedItems, extraParams)
      return true
    } catch (error) {
      console.error(`Error populating ${type}:`, error)
      return false
    }
  }

  return {
    populateSelectableItems
  }
}
